import { repeat } from 'lodash';

export const columnify = (columns: string[], width = 15, separator = '-') => {
  const end = columns.length - 1;
  return columns
    .map((text, index) => (index < end ? `${text} ${repeat(separator, width - text.length)}` : text))
    .join(' ');
};
